module.exports = __webpack_public_path__ + "static/media/complete.2a8b1b8d.png";